import { SUCCESS_CODE } from '@/constants'
import Mock from 'mockjs'

export default [
  // 组织架构目录结构
  {
    url: '/mock/v1/department/list',
    method: 'get',
    response: () => {
      const tableColumns: any[] = Array.from({ length: 10 }).map((_, index) => ({
        id: `${index}`,
        parentId: 0,
        level: 0,
        count: 10,
        label: Mock.mock('@csentence(3, 5)'),
        children: [
          {
            id: `1-${index}`,
            parentId: 1,
            level: 1,
            count: 2,
            label: Mock.mock('@csentence(3, 5)'),
            children: [
              {
                id: Mock.mock('@guid'),
                parentId: 2,
                level: 2,
                count: 2,
                label: Mock.mock('@csentence(3, 5)'),
                children: [
                  {
                    id: Mock.mock('@guid'),
                    parentId: 2,
                    level: 2,
                    count: 2,
                    label: Mock.mock('@csentence(3, 5)'),
                    children: [
                      {
                        id: Mock.mock('@guid'),
                        parentId: 2,
                        level: 2,
                        count: 2,
                        label: Mock.mock('@csentence(3, 5)'),
                        children: [
                          {
                            id: Mock.mock('@guid'),
                            parentId: 2,
                            level: 2,
                            count: 2,
                            label: Mock.mock('@csentence(3, 5)'),
                            children: [
                              {
                                id: Mock.mock('@guid'),
                                parentId: 2,
                                level: 2,
                                count: 2,
                                label: Mock.mock('@csentence(3, 5)')
                              },
                              {
                                id: Mock.mock('@guid'),
                                parentId: 2,
                                level: 2,
                                count: 2,
                                label: Mock.mock('@csentence(3, 5)'),
                                children: [
                                  {
                                    id: Mock.mock('@guid'),
                                    parentId: 2,
                                    level: 2,
                                    count: 2,
                                    label: Mock.mock('@csentence(3, 5)')
                                  },
                                  {
                                    id: Mock.mock('@guid'),
                                    parentId: 2,
                                    level: 2,
                                    count: 2,
                                    label: Mock.mock('@csentence(3, 5)')
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            id: Mock.mock('@guid'),
                            parentId: 2,
                            level: 2,
                            count: 2,
                            label: Mock.mock('@csentence(3, 5)')
                          }
                        ]
                      },
                      {
                        id: Mock.mock('@guid'),
                        parentId: 2,
                        level: 2,
                        count: 2,
                        label: Mock.mock('@csentence(3, 5)')
                      }
                    ]
                  },
                  {
                    id: Mock.mock('@guid'),
                    parentId: 2,
                    level: 2,
                    count: 2,
                    label: Mock.mock('@csentence(3, 5)')
                  }
                ]
              },
              {
                id: `3-${index}`,
                parentId: 2,
                level: 2,
                count: 2,
                label: Mock.mock('@csentence(3, 5)')
              }
            ]
          },
          {
            id: `4-${index}`,
            parentId: 0,
            level: 1,
            count: 2,
            label: Mock.mock('@csentence(3, 5)')
          }
        ]
      }))
      return {
        code: SUCCESS_CODE,
        data: tableColumns
      }
    }
  },
  // 获取菜单
  {
    url: '/mock/v1/menu/list',
    method: 'get',
    response: () => {
      return {
        code: SUCCESS_CODE,
        data: [
          {
            id: Mock.mock('@guid'),
            name: '资产概览',
            type: '1'
          },
          {
            id: Mock.mock('@guid'),
            name: '资产中心',
            type: '1',
            children: [
              {
                id: Mock.mock('@guid'),
                name: '元数据',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '知识库',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '厂商库',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '集成库',
                type: '2'
              }
            ]
          },
          {
            id: Mock.mock('@guid'),
            name: '数据查看',
            type: '1',
            children: [
              {
                id: Mock.mock('@guid'),
                name: '面板',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '图表',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: 'SQL开发',
                type: '2'
              }
            ]
          },
          {
            id: Mock.mock('@guid'),
            name: '数据查看',
            type: '1'
          },
          {
            id: Mock.mock('@guid'),
            name: '数据服务',
            type: '1',
            children: [
              {
                id: Mock.mock('@guid'),
                name: 'API管理',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '调用日志',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '监控',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '数据服务类目',

                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '数据源连接',
                type: '2'
              }
            ]
          },
          {
            id: Mock.mock('@guid'),
            name: '系统管理',
            type: '1',
            children: [
              {
                id: Mock.mock('@guid'),
                name: '用户管理',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '角色管理',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '菜单管理',
                type: '2'
              },
              {
                id: Mock.mock('@guid'),
                name: '部门管理',

                type: '2'
              }
            ]
          }
        ]
      }
    }
  }
]
